import React from 'react';

var LoaderContent = function (_a) {
    var _b = _a.logoRenderer, logoRenderer = _b === void 0 ? null : _b, _c = _a.progressRenderer, progressRenderer = _c === void 0 ? null : _c, _d = _a.providerRenderer, providerRenderer = _d === void 0 ? null : _d;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'loading-animation-position' }),
        React.createElement("div", { className: 'loading-content content-hidden' },
            React.createElement("div", { className: 'loading-content-middle' }, logoRenderer),
            progressRenderer && progressRenderer,
            providerRenderer && React.createElement("div", { className: 'loading-content-bottom' }, providerRenderer))));
};

export { LoaderContent };
